/**
 * IcmLink.tsx
 * ----------------
 * Creates a hyperlink to an IcM incident.
 */

import { Link } from '@fluentui/react/lib/Link';
import * as React from 'react';

/**
 * Component properties
 */

interface IcmLinkProps {
    icmId: number;
}

export function IcmLink (props: IcmLinkProps) {
    const { icmId } = props;

    return (
        <Link
            href={`https://portal.microsofticm.com/imp/v3/incidents/details/${icmId}`}
            rel="noopener noreferrer"
            target="_blank">
            IcM ID {icmId}
        </Link>
    );
}
